import { useAuthContext } from '../contexts/AuthContext';

export const useAuth = () => {
  const context = useAuthContext();
  
  return {
    // State
    isAuthenticated: context.isAuthenticated,
    user: context.user,
    loading: context.loading,
    error: context.error,
    statusCode: context.statusCode,
    
    // Actions
    login: context.login,
    logout: context.logout,
    register: context.register,
    updateUser: context.updateUser,
    clearError: context.clearError,
    
    // ID Helper functions
    getPrimaryId: context.getPrimaryId,
    getTeacherId: context.getTeacherId,
    
    teacherId: context.getTeacherId(),
    userName: context.user?.fullName || context.user?.email || 'Teacher',
    
    isTeacher: context.user?.role === 'teacher',
    isStudent: context.user?.role === 'student',
    isAdmin: context.user?.role === 'admin',
    hasRole: (role) => context.user?.role === role,
    hasAnyRole: (roles) => roles.includes(context.user?.role)
  };
};